/**
 * @generated SignedSource<<ddfb1d87229e6c3ddcdc745b8cec697f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type EventPrimaryChargeType = "PER_PERSON" | "PER_SIGN_UP";
export type EventRegistrationType = "CUSTOMER" | "GUEST" | "MEMBER";
export type EventSignUpStatus = "CONFIRMED" | "DRAFT";
export type OrderStatus = "CANCELED" | "DRAFT" | "EMPTY" | "FULLY_PAID" | "FULLY_REFUNDED" | "OPEN" | "PARTIALLY_PAID" | "PARTIALLY_REFUNDED";
export type PrePaymentRequirement = "COLLECT_CARD_ON_FILE" | "FULL" | "NONE";
export type SquareLoyaltyRewardStatus = "DELETED" | "ISSUED" | "REDEEMED";
import { FragmentRefs } from "relay-runtime";
export type EventSignupSummaryPaymentSummary_signUp$data = {
  readonly event: {
    readonly eventSeries: {
      readonly facility: {
        readonly id: string;
        readonly isEventPrePaymentEnabled: boolean;
      };
    };
    readonly id: string;
    readonly prePaymentRequirement: PrePaymentRequirement | null | undefined;
    readonly primaryChargeType: EventPrimaryChargeType | null | undefined;
  };
  readonly id: string;
  readonly orders: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly availableLoyaltyRewards?: {
          readonly balance: number;
        } | null | undefined;
        readonly id: string;
        readonly loyaltyEnrollmentOffer?: {
          readonly points: number;
        } | null | undefined;
        readonly orderOwner?: {
          readonly id: string;
          readonly squareLoyaltyAccount: {
            readonly id: string;
          } | null | undefined;
        } | null | undefined;
        readonly squareLoyaltyRewards?: ReadonlyArray<{
          readonly id: string;
          readonly loyaltyAccount: {
            readonly id: string;
          } | null | undefined;
          readonly loyaltyCustomerId: string | null | undefined;
          readonly points: number;
          readonly rewardTier: {
            readonly id: string;
            readonly name: string;
          };
          readonly status: SquareLoyaltyRewardStatus;
        }>;
        readonly status: OrderStatus | null | undefined;
        readonly total: number | null | undefined;
        readonly totalTaxes: number | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"PatronCheckoutLoyaltyRewardsEnrollmentOffer_order" | "PatronCheckoutLoyaltyRewards_order">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly paymentCardOnFile: {
    readonly id: string;
  } | null | undefined;
  readonly registrations: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly formResponses: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly booleanValue: boolean | null | undefined;
              readonly id: string;
              readonly questionConfiguration: {
                readonly id: string;
              };
              readonly stringValue: string | null | undefined;
              readonly transportationType: {
                readonly id: string;
              } | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly id: string;
        readonly index: number | null | undefined;
        readonly payingCustomer?: {
          readonly id: string;
        } | null | undefined;
        readonly payingMember?: {
          readonly id: string;
        } | null | undefined;
        readonly primaryChargeType: {
          readonly chargeRuleSet: {
            readonly chargeRules: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly price: number;
                } | null | undefined;
              } | null | undefined> | null | undefined;
            } | null | undefined;
          };
          readonly id: string;
        } | null | undefined;
        readonly registrant: {
          readonly id: string;
        } | null | undefined;
        readonly type: EventRegistrationType | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly status: EventSignUpStatus;
  readonly waitlistIndex: number | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"EventSignupSummaryTotal_signUp">;
  readonly " $fragmentType": "EventSignupSummaryPaymentSummary_signUp";
};
export type EventSignupSummaryPaymentSummary_signUp$key = {
  readonly " $data"?: EventSignupSummaryPaymentSummary_signUp$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventSignupSummaryPaymentSummary_signUp">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v2 = [
  (v0/*: any*/)
],
v3 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  }
],
v4 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Member",
    "kind": "LinkedField",
    "name": "payingMember",
    "plural": false,
    "selections": (v2/*: any*/),
    "storageKey": null
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "points",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "patronLoyalty"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventSignupSummaryPaymentSummary_signUp",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "waitlistIndex",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Event",
      "kind": "LinkedField",
      "name": "event",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "prePaymentRequirement",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "EventSeries",
          "kind": "LinkedField",
          "name": "eventSeries",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Facility",
              "kind": "LinkedField",
              "name": "facility",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isEventPrePaymentEnabled",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "primaryChargeType",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SquareCardOnFile",
      "kind": "LinkedField",
      "name": "paymentCardOnFile",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v3/*: any*/),
      "concreteType": "EventRegistrationConnection",
      "kind": "LinkedField",
      "name": "registrations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventRegistrationEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "index",
                  "storageKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v4/*: any*/),
                  "type": "MemberEventRegistration",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v4/*: any*/),
                  "type": "GuestEventRegistration",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Customer",
                      "kind": "LinkedField",
                      "name": "payingCustomer",
                      "plural": false,
                      "selections": (v2/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "type": "CustomerEventRegistration",
                  "abstractKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EventRegistrationChargeType",
                  "kind": "LinkedField",
                  "name": "primaryChargeType",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ChargeRuleSet",
                      "kind": "LinkedField",
                      "name": "chargeRuleSet",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": [
                            {
                              "kind": "Literal",
                              "name": "first",
                              "value": 1
                            }
                          ],
                          "concreteType": "ChargeRuleConnection",
                          "kind": "LinkedField",
                          "name": "chargeRules",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "ChargeRuleEdge",
                              "kind": "LinkedField",
                              "name": "edges",
                              "plural": true,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "ChargeRule",
                                  "kind": "LinkedField",
                                  "name": "node",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "price",
                                      "storageKey": null
                                    }
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": "chargeRules(first:1)"
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "registrant",
                  "plural": false,
                  "selections": (v2/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": (v3/*: any*/),
                  "concreteType": "EventFormResponseConnection",
                  "kind": "LinkedField",
                  "name": "formResponses",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "EventFormResponseEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "EventFormResponse",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "booleanValue",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "stringValue",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "TransportationType",
                              "kind": "LinkedField",
                              "name": "transportationType",
                              "plural": false,
                              "selections": (v2/*: any*/),
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "FormQuestionConfiguration",
                              "kind": "LinkedField",
                              "name": "questionConfiguration",
                              "plural": false,
                              "selections": (v2/*: any*/),
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": "formResponses(first:50)"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "registrations(first:50)"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "active",
          "value": true
        }
      ],
      "concreteType": "OrderConnection",
      "kind": "LinkedField",
      "name": "orders",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OrderEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Order",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "total",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "totalTaxes",
                  "storageKey": null
                },
                {
                  "condition": "patronLoyalty",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "OrderAvailableLoyaltyRewards",
                      "kind": "LinkedField",
                      "name": "availableLoyaltyRewards",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "balance",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "OrderLoyaltyEnrollmentOffer",
                      "kind": "LinkedField",
                      "name": "loyaltyEnrollmentOffer",
                      "plural": false,
                      "selections": [
                        (v5/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Customer",
                      "kind": "LinkedField",
                      "name": "orderOwner",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "SquareLoyaltyAccount",
                          "kind": "LinkedField",
                          "name": "squareLoyaltyAccount",
                          "plural": false,
                          "selections": (v2/*: any*/),
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "SquareLoyaltyReward",
                      "kind": "LinkedField",
                      "name": "squareLoyaltyRewards",
                      "plural": true,
                      "selections": [
                        (v0/*: any*/),
                        (v5/*: any*/),
                        (v1/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "loyaltyCustomerId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "SquareLoyaltyAccount",
                          "kind": "LinkedField",
                          "name": "loyaltyAccount",
                          "plural": false,
                          "selections": (v2/*: any*/),
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "SquareLoyaltyRewardTier",
                          "kind": "LinkedField",
                          "name": "rewardTier",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "name",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "PatronCheckoutLoyaltyRewards_order"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "PatronCheckoutLoyaltyRewardsEnrollmentOffer_order"
                    }
                  ]
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "orders(active:true)"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventSignupSummaryTotal_signUp"
    }
  ],
  "type": "EventSignUp",
  "abstractKey": null
};
})();

(node as any).hash = "1863077b4f53d6918fd42d824996f578";

export default node;
